const initSlideOutPanels = () => {

  // When a link is clicked with an anchor, see if a div with that ID exists, and add the is-active class
  $('a[href*="#"]').click(function (e) {
    const id = this.hash.slice(1);
    var target = $(`#${id}.slide-out-panel`);
    target = target.length ? target : $('.slide-out-panel[name=' + this.hash.slice(1) + ']');

    // Prevent scrolling and show panel
    if (target.length) {
      e.preventDefault();
      $(target).addClass('is-active');
    }
  });


  // If the user clicks outside it, close it
  $('.slide-out-panel').click(function (e) {
    var clickedElement = e.target;

    // Only close it if the clicked element has this class, ignore children
    if (clickedElement.className === 'slide-out-panel is-active') {
      $(this).removeClass('is-active');
    }
  });

  // Focus search bar when open
  $('.js-site-search').click(function () {
    window.setTimeout(function () {
      $('.slide-out-search-box').focus();
    }, 600);
  });
}

export default initSlideOutPanels;